import Home from './Home.pid-bank-lists-details.vue'

export default {
  Home
}